import React from 'react';
import './Footer.css';

const Footer = () => {
    
  
const teamMembers = [
    {  
        name: "Lucy",
        hobby: "Travelling",
        desc: "I enjoy exploring new places, trying different foods and experiencing new cultures."
    },
    {  
        name: "Betty",
        hobby: "Painting",
        desc: "I enjoy painting because I find it very therapeutic and I love seeing what I've created at the end of it."
    },
    {
        name: "Maisie",
        hobby: "Running",
        desc: "I enjoy the welcome escape from daily stresses and routines, the sense of accomplishment ('runner's high'), and spending time outdoors."
    },
    {
        name: "Frankie",
        hobby: "Cooking",
        desc: "I enjoy trying out new recipes and sharing with those around me - and of course, I mainly like cooking because I like eating!"
    },
    {
        name: "Jas",
        hobby: "Running",
        desc: "I'm a runner in a complicated love affair with Garmin, forever questioning if the wrist tan is worth it. Always chasing the sun, new PBs, and that runner's high!"
    }
];
    return (
        <footer className="footer">
         <div className="footer-content">   
         <div className="about-us">
          <h3>About Us</h3>  
         </div> 

        <div className="team-members">
            {teamMembers.map((member, index) => (
                <div key={index} className="team-member">
                    <h4>{member.name}</h4>
                    <p><strong>Hobby:</strong> {member.hobby}</p>
                    <p>{member.desc}</p>
                </div>
            ))}
            </div> 
         </div>
        </footer>
    );
};
export default Footer;